module.exports = __webpack_public_path__ + "static/media/encode.a55da1e5.svg";